import * as React from 'react';
import { cn } from '@/lib/utils';

export interface EmptyStateProps {
  title: React.ReactNode;
  description?: React.ReactNode;
  /** Usually a Button leading to the first item. */
  action?: React.ReactNode;
  /** Decorative icon above the title. */
  icon?: React.ReactNode;
  className?: string;
}

/** Placeholder for a list without entries: title, copy, optional action. */
export function EmptyState({
  title,
  description,
  action,
  icon,
  className,
}: EmptyStateProps) {
  return (
    <div
      className={cn(
        'flex flex-col items-center justify-center gap-3 rounded-card bg-paper-2 px-6 py-12 text-center ring-1 ring-line',
        className
      )}
    >
      {icon && (
        <div className="text-mute" aria-hidden="true">
          {icon}
        </div>
      )}
      <h2 className="dc-h3 text-base text-ink">{title}</h2>
      {description && (
        <p className="max-w-prose text-sm text-ink-2">{description}</p>
      )}
      {action && <div className="mt-2 flex items-center gap-2">{action}</div>}
    </div>
  );
}
